import { createContext, useContext, useState, useCallback } from "react";
import { fireLead } from "@/lib/analytics";

const LeadContext = createContext(null);

export const LeadProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [meta, setMeta] = useState({ plan: null, source: "cta" });

  const openLead = useCallback((info = {}) => {
    setMeta({ plan: info.plan || null, source: info.source || "cta" });
    setOpen(true);
    fireLead({ plan: info.plan || "unknown", source: info.source || "cta" });
  }, []);

  const closeLead = useCallback(() => setOpen(false), []);

  return (
    <LeadContext.Provider value={{ open, meta, openLead, closeLead, setOpen }}>
      {children}
    </LeadContext.Provider>
  );
};

export const useLead = () => {
  const ctx = useContext(LeadContext);
  if (!ctx) throw new Error("useLead must be used within LeadProvider");
  return ctx;
};
